import type { ReactNode } from 'react'

import { FormattedMessage } from 'react-intl'

import { OrderedItem } from 'components/OrderedList'

type Props = {
	icon: ReactNode
	title: ReactNode
	isCompleted?: boolean
}

export const Step = ({ icon, title, isCompleted = false }: Props) => (
	<OrderedItem icon={icon} title={title} isHighlighted={isCompleted}>
		{isCompleted ? (
			<FormattedMessage id='flow.nextSteps.completed' defaultMessage='Completed' />
		) : (
			<FormattedMessage id='flow.nextSteps.waiting' defaultMessage='Waiting' />
		)}
	</OrderedItem>
)
